/**
 * Created by xuyq on 2022/6/28.
 */
import Vue from "vue";
import defaultApp from "./DefaultApp.vue";
import i18n from '../src/lang'
import vuetify from "@/plugins/vuetify.js";
import store from '../src/store'
import {module,authV2,router,logOut,event,setDataProxy,createMenu,settings} from '@/myops/core'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

/**
 * Created by xuyq on 2021/1/7.
 */
export class platform {
    constructor(ops) {
        this.module = new module(this)
        this.router = router
        this.store = store
        this.i18n = i18n
        this.event = event
        this.loadingIdx = 0
        const {modules,name} = ops
        if(modules){
            this.addModule(modules,name)
        }
        Vue.prototype.$app = this
        this.init()
    }

    init(){
        this.event.$on('authorization',()=>{
            let href = window.location.href
            let hash = href.substr(href.indexOf('#/') + 2, href.length - href.indexOf('#/') - 1)
            if(hash.indexOf('login')>-1){
                return
            }
            // if(settings.isESO){
            //     location.href = `/login/?redirect=${btoa(href)}`
            // } else {
            //     router.push(`/login?redirect=${btoa(href)}`)
            // }
        })
    }
    createMenu(menu){
        return createMenu(menu)
    }
    addModule(modules,name){
        this.module.addModule(modules,name)
        return this
    }
    addStore(key,store){
        if(module){
            this.store.registerModule(key,store)
        }
    }


    on(event,handler){
        this.event.$on(event,handler)
    }

    off(event){
        this.event.$off(event)
    }

    logout(){
        settings.isESO?authV2.signOut():logOut()
    }

    showLoading(){
        this.loadingIdx++
        let {commit} = this.store
        commit('app/SET_SHOWLOADING',true)
    }

    hideLoading(){
        this.loadingIdx--
        if(this.loadingIdx===0){
            let {commit} = this.store
            commit('app/SET_SHOWLOADING',false)
        }
    }

    setProxy(proxy){
        setDataProxy(proxy)
        return this
    }

    async render(cfg){
        let options = Object.assign({
            app:defaultApp,
            el:'#app'
        },cfg)

        if (settings.isESO) {
            let hasAccount = await authV2.initialize()
            if (!hasAccount) {
                return
            }
        }

        new Vue({
            router,
            store,
            vuetify,
            i18n,
            render: h => h(options.app)
        }).$mount(options.el)
    }
}

// export * from '../src/vuetify/layouts'
import '../src/router'
export * from '../src/dataProxy'

// export {Message} from '../src/vuetify/component/message'
// export {MessageBox} from '../src/vuetify/component/messageBox'
export {vuetify,i18n,store}

